
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h2>Payment Form </h2>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm summer-camp section-banner-bg-1">
    <!-- <div class="container">
    	<div class="sec-title text-center">
	            <h4>Pay<span >Payment</span></h4>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-8">
                <iframe src="https://ghrscf.com/melvin-louise-folder/payment_form.php" allowtransparency = "true" frameborder="0" width="100%" height="484px"></iframe>

            </div>
        </div>
    </div> -->
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <div class="sec-title text-center">
                <h2>Payment <span> Form</span></h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-5">
                <div class="widget_title inner-title">
                    <h4>TERMS AND CONDITIONS</h4>
                </div>
                <h6>Participants should bring the Following</h6>
                <ul class="list-style list-style1">
                    <li>Sport shoes / Canvas shoes</li>
                    <li>Water Bottles</li>
                    <li>Mask and Sanitizer</li>
                    <li>Snacks</li>
                </ul>
                <div class="widget_title inner-title">
				    <h4>Important Instructions:</h4>
                </div>
                <ul class="list-style list-style1">
                    <li>Jewellery (Gold, Silver (or) imitation), Money with participant is strictly not allowed.</li>
                    <li>Admission into the Camp is considered only after payment of entire FEE</li>
                    <li>The application forms duly filled in must be submitted along with 2 pass post size photographs</li>
                    <li>Interested students can carry cameras and mobile phones at their own responsibility and Risk.</li>
                    <li>Participants should strictly follow the instructions of the management staff and trainers.</li>
                    <li>Only parents or guardians should pick and drop the kid to the camp and register their attendance daily at the counter by showing ID</li>
                    <li>Cancellation of admission is entirely at the discretion of Parents / Guardian.</li>
                    <li>Fee is non-refundable In case of cancellation.</li>
                    <!-- <li>No refund will take place in absence of 80% attendance&nbsp;</li> -->
                    <li>To claim refund of Rs. 500, minimum 80% attendance of the paticipants is a must.</li>
                    <li>The Camp organisers are not responsible for any kind of snacks or refreshment arrangements</li>
                    <li>Organisers have all the rights to make necessary changes in time table in case if required or in emergency</li>
                </ul>
                <a routerLink="/photogallery" class="btn button--effect-2 mx-2 btn-color w-50 mt-5"> Go to Gallery
                    <i class="fa fa-angle-double-right mx-1" aria-hidden="true"></i>
                </a>
            </div>
            <div class="col-md-7">
                <form  class="row gx-3 comments-form contact-form">
                    <div class="col-xs-12">
                        <div class="styled-input wide form-group">
                            <label>Name</label>
                            <input type="text" formControlName="studentName" id="studentName" class="form-control">

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Age</label>
                            <input type="text" formControlName="age"  id="age" class="form-control">

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Blood Group</label>
                            <input type="text" formControlName="blood_group"  id="blood_group" class="form-control">

                        </div>
                    </div>
                    <div class="col-xs-12">
                        <div class="styled-input">
                            <label>School/College/Academy Name</label>
                            <input type="text" formControlName="instituteName" id="instituteName" class="form-control"/>

                        </div>
                    </div>
                     <div class="col-xs-12">
                        <div class="styled-input wide">
                            <label>Address</label>
                            <textarea formControlName="address" id="address" class="form-control"></textarea>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Pincode</label>
                            <input type="text" formControlName="zip" maxlength="6" id="zip" class="form-control"/>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Parent's Mobile Number</label>
                            <input type="text" formControlName="parent_mobileNo" maxlength="10" id="parent_mobileNo" class="form-control"/>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Student's E-mail</label>
                            <input type="text" formControlName="stud_email" id="stud_email" class="form-control"/>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Parent's E-mail</label>
                            <input type="text" formControlName="parent_email" id="parent_email" class="form-control"/>

                        </div>
                    </div>
                     <div class="col-xs-12">
                        <div class="styled-input wide">
                            <label>1st Parent/Guardian Name</label>
                            <input type="text" formControlName="first_guardian" id="first_guardian" class="form-control"/>

                        </div>
                    </div>
                  <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Cell Phone</label>
                            <input type="text" formControlName="first_cell_phone"  maxlength="10" id="first_cell_phone" class="form-control"/>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Place of Work</label>
                            <input type="text" formControlName="first_work_place" id="first_work_place" class="form-control"/>

                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <div class="styled-input">
                            <label>Work Phone</label>
                            <input type="text" formControlName="first_work_phone" maxlength="10" id="first_work_phone" class="form-control"/>

                        </div>
                    </div>
                     <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Emergency Contact</label>
                            <input type="text" formControlName="emr_contact" maxlength="10" id="emr_contact" class="form-control"/>

                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="styled-input">
                            <label>Relationship</label>
                            <input type="text" formControlName="relationship" id="relationship" class="form-control"/>

                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <div class="styled-input">
                            <label>category sport</label>
                            <input type="text" formControlName="category_sport"  id="category_sport" class="form-control">
                        </div>
                    </div>
                    <div class="form-group col-md-12 col-sm-12">
                        <table class="table" style="border: 1px solid #000; padding: 5px">
                            <tbody>
                                <tr>
                                    <td colspan="3"><b>Name and phone number(s) of person(s) other than parents allowed to pick up you child</b></td>
                                </tr>
                                <tr>
                                    <td>1.</td>
                                    <td><input type="text" class="form-control" formControlName="pick_candidate_one" name="pick_candidate_one" value=""/></td>
                                    <td><input type="text" class="form-control" formControlName="pick_phone_one" maxlength="10" name="pick_phone_one" value=""/></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group mt-2">
                            <input type="submit" name="submit" class="btn button--effect-1 w-50" value="Pay Rs.500" id="send_button" />
                    </div>
                </form>
            </div>

        </div>
    </div>
</section>
